import { UserProfileDropdown } from "@/components/UserProfile";
import { Button } from "@acme/ui/button";
import { Input } from "@acme/ui/input";
import { DiGithubBadge } from "react-icons/di";
import { useNavigate, useLocation } from "react-router";
import { authClient } from "../context/authClient";

export const LoginPage = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	const redirectUrl = params.get("redirect") || "/";
	const { data } = authClient.useSession();
	return (
		<div className="flex flex-col items-center justify-center gap-3">
			<div className="text-primary">Login:</div>
			{data?.session ? (
				<Button onClick={() => authClient.signOut()}>Logout</Button>
			) : (
				<Button
					onClick={async () => {
						authClient.signIn.social({
							provider: "github",
							callbackURL: `http://localhost:5173${redirectUrl}`,
						});
					}}
					variant="outline"
				>
					<DiGithubBadge />
					Login with Github
				</Button>
			)}
			<Button variant="ghost" onClick={() => navigate(-1)}>
				Back
			</Button>
		</div>
	);
};
